import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="bg-background-50 border-t border-foreground-950/10 scroll-mt-16">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <p className="text-xs tracking-[0.25em] text-primary-600 font-label">FAQ · 常见问题</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              看片前你可能想问的
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于站点状态、更新频率和播放速度的常见疑问，都整理在这里了。
            </p>
          </div>

          <div className="lg:col-span-2 border-t border-foreground-950/10">
            {faqs.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div key={item.id} className="border-b border-foreground-950/10">
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                      {item.q}
                    </span>
                    <span className="w-6 h-6 shrink-0 flex items-center justify-center text-foreground-500">
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600 animate-rise">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}